import type { BuiltInNode, Node } from '@xyflow/react';
import PipelineStageNode from './PipelineStageNode';

export const initialNodes = [
  { 
    id: 'stage-1', 
    type: 'input', 
    position: { x: 0, y: 0 }, 
    data: { label: 'Build Stage' } 
  },
  {
    id: 'stage-2',
    type: 'default',
    position: { x: 200, y: 0 },
    data: { label: 'Test Stage' },
  },
  { 
    id: 'stage-3', 
    type: 'default',
    position: { x: 400, y: 0 }, 
    data: { label: 'Deploy Stage' } 
  },
  {
    id: 'stage-4',
    type: 'output',
    position: { x: 600, y: 0 },
    data: { label: 'Complete' },
  },
] satisfies Node[];

export const nodeTypes = {
  stageNode: PipelineStageNode,
};

// Export the custom node type
export type CustomNodeType = BuiltInNode;